/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthDeclarationDynamicFormAliases {
  ACCESSIBILITY_0 = 'accessibility-0',
  APPLICATION_BAR_0 = 'application-bar-0',
  AVATAR_USER = 'avatar-user',
  BUTTON_FINISH = 'button-finish',
  BUTTON_NO_CANCEL = 'button-no-cancel',
  BUTTON_NO_PRINT = 'button-no-print',
  BUTTON_NO_SEND = 'button-no-send',
  BUTTON_PRINT = 'button-print',
  BUTTON_YES_CANCEL = 'button-yes-cancel',
  BUTTON_YES_SEND = 'button-yes-send',
  CHECKBOX = 'checkbox',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DYNAMIC_FIELDS_QUESTIONNAIRE = 'dynamic-fields-questionnaire',
  FETCH_HAEDER = 'fetch-haeder',
  FETCH_PRIVACY_WARNING = 'fetch-privacy-warning',
  FETCH_QUESTIONNAIRE = 'fetch-questionnaire',
  FIELD_0 = 'field-0',
  FIELD_CHECKBOX = 'field-checkbox',
  FIELD_HTML = 'field-html',
  FIELD_PRIVACY_WARNING = 'field-privacy-warning',
  FIELD_USER = 'field-user',
  FIELD_USER_HEIGHT = 'field-user-height',
  FIELD_USER_IMC = 'field-user-imc',
  FIELD_USER_WEIGHT = 'field-user-weight',
  FORM_PRIVACY_WARNING = 'form-privacy-warning',
  FORM_QUESTIONNAIRE = 'form-questionnaire',
  FORM_USER = 'form-user',
  FRAGMENT_FOOTER = 'fragment-footer',
  HPMS_CHECKBOX = 'hpms-checkbox',
  HPMS_CUSTOM_DIALOG_CANCEL = 'hpms-custom-dialog-cancel',
  HPMS_CUSTOM_DIALOG_PRINT = 'hpms-custom-dialog-print',
  HPMS_CUSTOM_DIALOG_SEND = 'hpms-custom-dialog-send',
  HPMS_REPORT_LIST = 'hpms-report-list',
  HPMS_TEXT_HTML = 'hpms-text-html',
  INPUT_HEIGHT = 'input-height',
  INPUT_IMC = 'input-imc',
  INPUT_WEIGHT = 'input-weight',
  LAYOUT_1 = 'layout-1',
  LAYOUT_4 = 'layout-4',
  MAPPER_0 = 'mapper-0',
  MAPPER_USER = 'mapper-user',
  MODAL_TERM = 'modal-term',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_11 = 'panel-11',
  PANEL_FINISH = 'panel-finish',
  PANEL_MODAL_TERM = 'panel-modal-term',
  PANEL_QUESTIONNAIRE = 'panel-questionnaire',
  ROOT_COMPONENT = 'root-component',
  TEXT_CANCEL = 'text-cancel',
  TEXT_PRINT = 'text-print',
  TEXT_SEND = 'text-send',
  TOAST_NOTIFICATION_FORM_FEEDBACK = 'toast-notification-form-feedback',
  TOAST_NOTIFICATION_PRIVACY_WARNING = 'toast-notification-privacy-warning',
}
export { HealthDeclarationDynamicFormAliases };
